import { render, staticRenderFns } from "./ProcessBucketPage.vue?vue&type=template&id=e2f61b06&scoped=true&"
import script from "./ProcessBucketPage.vue?vue&type=script&lang=js&"
export * from "./ProcessBucketPage.vue?vue&type=script&lang=js&"
import style0 from "./ProcessBucketPage.vue?vue&type=style&index=0&id=e2f61b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f61b06",
  null
  
)

export default component.exports